import { createContext } from "react";
import type { BrowserSessionContextValue } from "./browser-session-state";

export const BrowserSessionContext =
  createContext<BrowserSessionContextValue | null>(null);
